import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Helmet from 'react-helmet';
import Tab from 'react-bootstrap/lib/Tab';
import cns from 'classnames';

import BrandButton from 'components/BrandButton';
import CmsBlock from 'components/CmsBlock';
import DsbTabs from 'components/DsbTabs';
import DsbBookingTab from 'components/DsbBookingTab';
import Link from 'components/Link';
import withSearchWidget from 'helpers/withSearchWidget';
import { MakeGroupField } from 'components/forms/filters/vehicle/Make';
import { ModelGroupField } from 'components/forms/filters/vehicle/Model';
import { YearGroupField } from 'components/forms/filters/Year';
import { PriceGroupField } from 'components/forms/filters/Price';
import { DistanceGroupField } from 'components/forms/filters/Location/Distance';
import { GeoLocationGroupField } from 'components/forms/filters/Location/GeoLocation';
import { stringFormatter } from 'helpers/i18n';
import {
  PRICE_RANGE_NAME,
  YEAR_RANGE_NAME,
} from 'components/searchAds/constants';

import cn from './styles.local.less';
import './styles.global.less';

const FORM_NAME = 'dsbFormWidget';
const BUY_TAB = 'buyTab';
const DSB_TAB = 'dsbTab';
const APPOINTMENT_TAB = 'appointmentTab';

const formatters = {
  applyButton: stringFormatter(__('search.filters.applyButtonLabelWithCount')),
};

class DsbFormWidget extends PureComponent {
  static propTypes = {
    dsbBookingContent: PropTypes.object,
    dsbHtml: PropTypes.string,
    dsbScript: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    onWidgetLoad: PropTypes.func.isRequired,
    searchLink: PropTypes.string,
    searchLinkExtra: PropTypes.string,
  };

  handleTabSelect = (tabKey) => {
    const { onWidgetLoad } = this.props;

    if (tabKey === DSB_TAB || tabKey === APPOINTMENT_TAB) {
      onWidgetLoad();
    }
  };

  renderControlLabel({ className, ...props }) {
    return <ControlLabel className={cns(className, cn.label)} {...props} />;
  }

  render() {
    const {
      dsbBookingContent,
      dsbHtml,
      dsbScript,
      isLoading,
      searchLink,
      searchLinkExtra,
    } = this.props;
    const props = {
      ControlLabel: this.renderControlLabel,
    };

    return (
      <DsbTabs
        id="top-dsb-widget"
        animation={false}
        defaultActiveKey={BUY_TAB}
        className={cns(cn.root, 'dsb-tabs-widget')}
        onSelect={this.handleTabSelect}
      >
        <Tab title={__('dsbwidget.tabs.header.buy')} eventKey={BUY_TAB}>
          <div>
            <Row>
              <Col md={6}>
                <MakeGroupField formName={FORM_NAME} {...props} />
              </Col>
              <Col md={6}>
                <ModelGroupField formName={FORM_NAME} {...props} />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <YearGroupField
                  {...props}
                  name={`${YEAR_RANGE_NAME}.min`}
                  label={__('search.filters.year')}
                />
              </Col>
              <Col md={6}>
                <PriceGroupField
                  {...props}
                  name={`${PRICE_RANGE_NAME}.max`}
                  label={__('search.filters.price')}
                />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <GeoLocationGroupField
                  {...props}
                  formName={FORM_NAME}
                  label={__('search.filters.location')}
                />
              </Col>
              <Col md={6}>
                <DistanceGroupField
                  {...props}
                  formName={FORM_NAME}
                  label={__('search.filters.distance')}
                />
              </Col>
            </Row>

            <div className={cn.searchFooter}>
              <div>
                <BrandButton
                  bsSize="large"
                  className={cn.searchBtn}
                  disabled={isLoading}
                  componentClass={Link}
                  to={searchLink}
                >
                  {formatters.applyButton({ count: null })}
                </BrandButton>
              </div>

              <div>
                <Button
                  bsStyle="link"
                  className={cn.extraFiltersBtn}
                  componentClass={Link}
                  to={searchLinkExtra}
                >
                  {__('advancedSearch.title')}
                </Button>
              </div>
            </div>
          </div>
        </Tab>

        <Tab
          title={__('dsbwidget.tabs.header.assessment')}
          eventKey={DSB_TAB}
          className="dsb-cms-tab"
        >
          <CmsBlock content={dsbHtml} />
        </Tab>

        <Tab
          title={__('dsbwidget.tabs.header.appointmentBooking')}
          eventKey={APPOINTMENT_TAB}
          className="dsb-cms-tab"
        >
          <DsbBookingTab content={dsbBookingContent} />
        </Tab>

        <Helmet>
          <script>{dsbScript}</script>
        </Helmet>
      </DsbTabs>
    );
  }
}

export default withSearchWidget({
  form: FORM_NAME,
})(DsbFormWidget);
